import { Chip, ChipProps } from "@mui/material";
import { WasteContainerStatus } from "generated-graphql/graphql";

import { CONTAINER_STATUS_LABELS } from "./containerDisplay";

/**
 * Chips follow the design-system spec: small, outlined, MUI semantic palette
 * colors (never solid dark fills). Neutral states omit `color` for the plain
 * grey outline.
 */
const STATUS_CHIP_COLORS: Record<WasteContainerStatus, ChipProps["color"] | undefined> = {
  [WasteContainerStatus.Staged]: undefined,
  [WasteContainerStatus.Accumulating]: "info",
  [WasteContainerStatus.Full]: "warning",
  [WasteContainerStatus.PendingPickup]: "warning",
  [WasteContainerStatus.Shipped]: "success",
};

export function WasteContainerStatusChip({ status }: { status: WasteContainerStatus }) {
  return (
    <Chip
      label={CONTAINER_STATUS_LABELS[status]}
      size="small"
      variant="outlined"
      color={STATUS_CHIP_COLORS[status]}
    />
  );
}
